import React from 'react';
import { SvgIcon } from '@mui/material';

const CustomArrowIcon = ({ direction = 'desc', ...props }) => (
    <SvgIcon {...props} viewBox="0 0 24 24" sx={{
        verticalAlign: 'middle',
        fontSize: '30px',  // Ensure fontSize is passed or inherited
        height: '20px',                      // 👈 Directly control height
        width: '28px',
        visibility: direction ? "visible" : "hidden", // takes space but hides
    }}>
        {direction === 'asc' ? (
            <path d="M4 16l8-8 l8 8" fill="none" stroke="currentColor" strokeWidth="2" />
        ) : direction === 'desc' ? (
            <path d="M4 8l8 8 l8-8" fill="none" stroke="currentColor" strokeWidth="2"/>
        ) : null}
    </SvgIcon>
);

export default CustomArrowIcon;
